import React, { Component } from 'react';
import { ShowSwallError,isEmpty } from '../../config'
import Back from '../UserComponent/BackofficeComponent/Backoffice'
class Dashboard extends Component {

    constructor() {
        super();
        this.state = {

            emailID: "",
            pwd: "",
            loginIP: "",
            loginBrowser: "",
            deviceType: "",
            userLocation: "",
            logIsp: "",
            ii: 0,
            actions: [],
            pLogo: ""
        }




    }
    componentDidMount(){  
        console.clear();
        if(localStorage.length<6 || !(localStorage.hasOwnProperty("userType")))
        {
            ShowSwallError("Please Login");
            setTimeout(() => {
                window.location.href="/"
              }, 3000);
      
        }
         
   }
   

    render() {

 
        return (

            
   

    <div class="app-content content " id="c11">
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">

            </div>
        </div>
    </div>
    
        
   
            


        );


    }
}
export default Dashboard